/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../../graphql/types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LastPlacedOrderDetailsQueryVariables = Types.Exact<{
  input: Types.OrdersInput;
}>;

export type LastPlacedOrderDetailsQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
          } | null;
        }>;
      }
    | { readonly __typename?: 'ValidationError' };
};

export const LastPlacedOrderDetailsDocument = gql`
  query LastPlacedOrderDetails($input: OrdersInput!) {
    orders(input: $input) {
      ... on OrdersResponseSuccess {
        __typename
        orders {
          id
          orderType
          restaurant {
            id
            name
            isOutpost
          }
          deliveryOrderDetail {
            id
          }
        }
      }
    }
  }
`;

export function useLastPlacedOrderDetailsQuery(
  options: Omit<
    Urql.UseQueryArgs<LastPlacedOrderDetailsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LastPlacedOrderDetailsQuery,
    LastPlacedOrderDetailsQueryVariables
  >({ query: LastPlacedOrderDetailsDocument, ...options });
}
